import React, { useMemo } from 'react'
import { StyleRankChange } from './RankStyle'

/** 排名变化 */
export const RankChange: React.FC<{
  rankChange: number
}> = ({ rankChange }) => {
  const rankComp = useMemo(() => {
    if (rankChange > 0) {
      return (
        <StyleRankChange className="up">
          <div className="rank">
            <i className="triangle triangle-up"></i>
            <i className="rank-num">{rankChange}</i>
          </div>{' '}
          <div className="tip">比昨天上升&nbsp;{rankChange}&nbsp;名</div>
        </StyleRankChange>
      )
    } else if (rankChange < 0) {
      return (
        <StyleRankChange className="down">
          <div className="rank">
            <i className="triangle triangle-down"></i>
            <i className="rank-num">{-rankChange}</i>
          </div>{' '}
          <div className="tip">比昨天下降&nbsp;{-rankChange}&nbsp;名</div>
        </StyleRankChange>
      )
    } else {
      return (
        <StyleRankChange className="normal">
          <div className="rank">-</div> <div className="tip">与昨天相同 </div>
        </StyleRankChange>
      )
    }
  }, [rankChange])

  return <>{rankComp} </>
}
